import React from 'react';

interface ICheckboxProps {
    fieldName?: string;
    onChange: (value: boolean, field: string) => void;
    checked?: boolean;
    required?: boolean;
    className?: string;
}

const Checkbox: React.FC<ICheckboxProps> = ({
    fieldName = '',
    onChange,
    checked,
    required,
    className,
    children,
}) => {
    const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        onChange(event.target.checked, fieldName);
    };

    return (
        <>
            <label className={`checkbox ${className || ''}`}>
                {required && <span className="question__required">* </span>}
                {children}
                <input
                    type="checkbox"
                    onChange={handleInputChange}
                    checked={checked}
                    required={required}
                />
                <span className="checkbox__checkmark" />
            </label>
        </>
    );
};

export default Checkbox;
